require('./_wks-define')('observable');


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/~/core-js/modules/es7.symbol.observable.js
 ** module id = 256
 ** module chunks = 12
 **/